class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartDrawer = document.querySelector('cart-drawer');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      // event.preventDefault();
      // this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    // cartLink.parentElement.addEventListener('mouseover', (event) => {
    //   if (cartDrawer.classList.contains("is-empty")) return false;
    //   event.preventDefault();
    //   this.open(cartLink);
    // });

    // let exitTO;
    // cartDrawer.addEventListener('mouseleave', (event) => {
    //   exitTO = setTimeout(() => {
    //     this.close();
    //   }, 500);
    // });
    // cartDrawer.addEventListener('mouseenter', (event) => {
    //   clearTimeout(exitTO);
    // });

    cartLink.parentElement.addEventListener('click', (event) => {
      if (cartDrawer.classList.contains("is-empty")) return false;
      event.preventDefault();
      if (cartDrawer.classList.contains("active")) {
        this.close();
      } else {
        this.open(cartLink);
      }
    });


    document.addEventListener('click', (event) => {
      if (!cartDrawer.contains(event.target) && !cartLink.contains(event.target)) {
        this.close();
      }
    });
    cartDrawer.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    let exitTO; 
    // cartDrawer.addEventListener('mouseleave', (event) => {
    //   exitTO = setTimeout(() => {
    //     this.close();
    //   }, 500);
    // });
    cartDrawer.addEventListener('mouseenter', (event) => {
      clearTimeout(exitTO);
    });
    
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        /*if (!triggeredBy) {
          setTimeout(() => {
            this.close();
            const $popupSection = $(".matching-accessories-pop-up-section.has_products");
            if($popupSection){
              const productHandle = $(".product__info-wrapper").data("product_id");
              const popupKey = `popup_shown_${productHandle}`;
              if (!sessionStorage.getItem(popupKey)) {
                setTimeout(() => {
                  $popupSection.fadeIn();
                  $("body").addClass("matching-accessories-popup-open"); // Add class to body
                  sessionStorage.setItem(popupKey, "true");
                }, 200);
              }
            }
          }, 3000);
        }*/
      },
      { once: true }
    );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const imageCache = this.cacheCartDrawerImages();

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.restoreCartDrawerImages(imageCache);
    if (parsedState.id) this.prioritizeCartDrawerImage(String(parsedState.id));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  cacheCartDrawerImages() {
    const cache = new Map();

    this.querySelectorAll('cart-drawer-items [data-quantity-variant-id]').forEach((input) => {
      const variantId = input.dataset.quantityVariantId;
      const img = input.closest('tr.cart-item')?.querySelector('.cart-item__image');

      if (!variantId || !img || !img.complete) return;

      cache.set(variantId, {
        src: img.currentSrc || img.src,
        srcset: img.srcset,
        sizes: img.sizes,
      });
    });

    return cache;
  }

  restoreCartDrawerImages(cache) {
    if (!cache?.size) return;

    cache.forEach((data, variantId) => {
      const input = this.querySelector(`cart-drawer-items [data-quantity-variant-id="${variantId}"]`);
      const img = input?.closest('tr.cart-item')?.querySelector('.cart-item__image');

      if (!img) return;

      if (data.srcset) img.srcset = data.srcset;
      if (data.sizes) img.sizes = data.sizes;
      img.src = data.src;
    });
  }

  prioritizeCartDrawerImage(variantId) {
    const input = this.querySelector(`cart-drawer-items [data-quantity-variant-id="${variantId}"]`);
    const img = input?.closest('tr.cart-item')?.querySelector('.cart-item__image');

    if (!img) return;

    img.loading = 'eager';
    img.fetchPriority = 'high';
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
